export const APK_NAME = "viveros.prod.signed_v"

export enum BUILDS_FORMAT_EXTENSIONS {
    APK = 'apk'
}